const productCategories = [
    {
        key: 0,
        name: "All Products",
        link: "products",
    },
    {
        key: 1,
        name: "Tables & Desk",
        link: "products",
    },
    {
        key: 2,
        name: "Furniture Sets",
        link: "products",
    },
    {
        key: 3,
        name: "Beds",
        link: "products",
    },
    {
        key: 4,
        name: "Sofas",
        link: "products",
    },
    {
        key: 5,
        name: "Bookcases & Shelves",
        link: "products",
    },
    {
        key: 6,
        name: "Cabinets & Cupboards",
        link: "products",
    },
    {
        key: 7,
        name: "Wardrobes",
        link: "products",
    },
    {
        key: 8,
        name: "Chairs",
        link: "products",
    },
    {
        key: 9,
        name: "Room Dividers",
        link: "products",
    },
    {
        key: 10,
        name: "Bar Furniture",
        link: "products",
    },
    {
        key: 11,
        name: "Decorations",
        link: "products",
    },
]

export default productCategories;